import React from 'react'
import ReactDOM from 'react-dom/client'
import { queryClient } from './App';
import '../app/globals.css'
import './index.css'
import {QueryClientProvider } from '@tanstack/react-query';
//...
import * as Sentry from "@sentry/react";
import InnerApp from './InnerApp';
import AuthStateProvider from './store/authentication';
import ConfirmationStageProvider from './store/confirmationStage';

Sentry.init({
  dsn: "https://4e48f83183094e6cb81cf5d0d4322138@o4507868338323456.ingest.us.sentry.io/4507878834110464",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/, /^https:\/\/enterprise\.thedevfactory\.ca\/?/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthStateProvider>
      <ConfirmationStageProvider>
      <QueryClientProvider client={queryClient}>
        <InnerApp />
      </QueryClientProvider>
      </ConfirmationStageProvider>
    </AuthStateProvider>
  </React.StrictMode>
)
